import React from 'react';
import { Box, Typography } from '@mui/material';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';

type TagListProps = {
  groupedSelectedTags: Record<string, { tags: string[]; color: string }>;
};

const TagList = ({ groupedSelectedTags }: TagListProps) => {
  const hasTags = Object.keys(groupedSelectedTags).length > 0;

  return (
    <Box
      border="1px solid #ddd"
      borderRadius="4px"
      padding="16px"
      minHeight="100px"
      display="flex"
      flexDirection="column"
      justifyContent={hasTags ? 'flex-start' : 'center'}
    >
      {hasTags ? (
        Object.entries(groupedSelectedTags).map(([category, groupInfo]) => (
          <Box key={category} mb={2}>
            <Typography fontWeight={600} fontSize="14px" mb={1}>
              {category}
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={1}>
              {groupInfo.tags.map((tagName) => (
                <Chip key={tagName} name={tagName} color={groupInfo.color} />
              ))}
            </Box>
          </Box>
        ))
      ) : (
        <Typography textAlign="left" className="secondary-text">
          No Tags Added
        </Typography>
      )}
    </Box>
  );
};

export default TagList;
